import React from 'react';
import Tooltip from 'rc-tooltip';

import TimesheetNumberCell from './TimesheetNumberCell';

const TimesheetNumberCellOverlay = ({tooltip, tooltipPlacement, showGig, isGig, onGigToggle, ...props}) => {
  const content = <span><TimesheetNumberCell {...props} showGig={showGig} isGig={isGig} onGigToggle={onGigToggle} /></span>;
  if (tooltip) {
    return (
      <Tooltip
        overlay={<span>{tooltip}</span>}
        placement={tooltipPlacement || 'top'}>
        {content}
      </Tooltip>
    );
  }
  return content;
};

export default TimesheetNumberCellOverlay;
